"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateCatalogOption = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const classnames_1 = __importDefault(require("classnames"));
const update_catalog_option_styles_1 = require("./update-catalog-option.styles");
const generic_1 = require("../../generic");
const upload_data_dialog_constants_1 = require("../upload-data-dialog.constants");
const localization_1 = require("../../../localization");
const UpdateCatalogOption = ({ title, text, isDisabled, isSelected, selectedMode, modeOptions, onSelect, onModeChange, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const handleModeChange = (e) => onModeChange === null || onModeChange === void 0 ? void 0 : onModeChange(e.target.value);
    const options = (0, react_1.useMemo)(() => ((modeOptions !== null && modeOptions !== void 0 ? modeOptions : [])
        .map((value) => ({ label: t({ key: upload_data_dialog_constants_1.UPDATE_DATA_MODE_TO_MESSAGE_KEY[value] }), value }))), [modeOptions, t]);
    return (react_1.default.createElement(update_catalog_option_styles_1.StyledUpdateCatalogOption, { onClick: !isDisabled ? onSelect : undefined, className: (0, classnames_1.default)({ 'update-catalog-option--selected': isSelected, 'update-catalog-option--disabled': isDisabled }) }, react_1.default.createElement("div", { className: "title" }, react_1.default.createElement(ui_components_1.Typography, { variant: "body2", className: "title-text", strong: true, accent: true }, title), react_1.default.createElement(material_1.Radio, { className: "title-check-icon", checked: isSelected, disabled: isDisabled })), react_1.default.createElement(ui_components_1.Typography, { variant: "body2", className: "hint", color: "textSecondary" }, text), isSelected && !isDisabled && options.length > 0 && (react_1.default.createElement(generic_1.Select, { placeholder: t({ key: 'UPDATE_CATALOG_OPTION_PLACEHOLDER' }), onChange: handleModeChange, value: selectedMode, options: options }))));
};
exports.UpdateCatalogOption = UpdateCatalogOption;
exports.default = exports.UpdateCatalogOption;
